<template>
    <Layout>
        <!-- create a wizard step section. Should show progress based on the prop step. Steps could be shipping, billing, review/confirm -->
        <div class="status-bar-wrapper">
            <div class="status-bar">
                <div class="steps" role="progressbar" aria-valuemin="1" aria-valuemax="3" aria-valuenow="2" aria-label="Checkout progress">
                    <Link v-if="step == 'billing' || step == 'review'" :href="shippingRoute" as="div" tag="" :class="{
                        step: true,
                        active: step === 'shipping',
                        available: true,
                        unavailable: step == 'shipping' ? step === 'billing' || step === 'review' : false
                    }">
                        <div class="step-number paragraph-details">1</div>
                        <span class="mobile-hidden step-label paragraph-details">Shipping</span>
                        <span class="desktop-hidden step-label paragraph-details">Shipping</span>
                    </Link>
                    <div :class="{
                        step: true,
                        active: true,
                        available: true,
                        unavailable: step == 'shipping' ? step === 'billing' || step === 'review' : false
                    }" v-else>
                        <div class="step-number paragraph-details">1</div>
                        <span class="mobile-hidden step-label paragraph-details">Shipping</span>
                        <span class="desktop-hidden step-label paragraph-details">Shipping</span>
                    </div>
                    <Link v-if="step == 'review'" as="div" :href="billingRoute" :class="{
                        step: true,
                        active: step === 'billing',
                        available: step === 'billing' || step === 'review',
                        unavailable: step === 'shipping'
                    }">
                        <div class="step-number paragraph-details">2</div>
                        <span class="mobile-hidden step-label paragraph-details">Billing & Payment</span>
                        <span class="desktop-hidden step-label paragraph-details">Billing</span>
                    </Link>
                    <div :class="{
                        step: true,
                        active: step === 'billing',
                        available: step === 'billing' || step === 'review',
                        unavailable: step === 'shipping'
                    }" v-else>
                        <div class="step-number paragraph-details">2</div>
                        <span class="mobile-hidden step-label paragraph-details">Billing & Payment</span>
                        <span class="desktop-hidden step-label paragraph-details">Billing</span>
                    </div>
                    <div :class="{
                        step: true,
                        active: step === 'review',
                        available: step === 'review',
                        unavailable: step === 'shipping' || step === 'billing'
                    }" aria-current="step">
                        <div class="step-number paragraph-details">3</div>
                        <span class="mobile-hidden step-label paragraph-details">Review & Confirm</span>
                        <span class="desktop-hidden step-label paragraph-details">Review</span>
                    </div>
                </div>
                <div class="cart-info">
                    <a @click.prevent="toggleDrawer" href="#" class="view-cart paragraph-details">View Cart</a>
                    <span class="cart-summary paragraph-details"> {{ currentList.total_styles }}  Styles <span class="opacity">|</span> {{ currentList.total_skus }}  SKUs <span class="opacity">|</span> {{ currentList.total_quantity }} Quantity
                        <span class="opacity">|</span> {{ subTotal }}</span>
                </div>
            </div>
        </div>
        <div class="b2b-checkout-wrapper billing-wrapper">
            <div class="flex-row-forced justify-between">
                <h2 class="headline-l b2b-checkout-header">{{ stepTitle }}</h2>
                <div class="b2b-checkout-header" id="review-header-place-order-btn"></div>
            </div>

        <div v-if="(shippingUsa && shippingRegion) && hasResaleCertificate == false && !uploadMessage.text" class="notification notification-alert">
            <div class="warning-title">
                <WarningIcon class="icon" alt="" role="presentation" loading="lazy" />
                <p class="title-m">Missing Resale Certificate</p>
            </div>
            <div class="body-content">
                <p class="paragraph-details text-rothcoCharcoal">Rothco does not have a valid resale certificate on file for you for the state of <b>{{ shippingRegion }}</b> (your ship-to for this order).
                    <upload-resale-certificate tag="u" v-model:uploadMessage="uploadMessage">Please submit your resale certificate by clicking here</upload-resale-certificate>. Failure to provide a valid resale certificate may delay processing of your order or may require sales tax to be added to your order. If you have already submitted a resale certificate, please ignore this message.</p>
            </div>
        </div>
        <div v-else-if="(shippingUsa && shippingRegion) && !!uploadMessage.text" 
            :class="{
                'notification ': true,
                'notification-success': uploadMessage.success,
                'notification-error': !uploadMessage.success
            }
        ">
            <p class="paragraph-details">{{ uploadMessage.text }}</p>
        </div>
        
        <slot></slot>
    </div>
    <PrimeDrawer
            v-model:visible="showDrawer"
            position="right"
            :pt:root="{
                class: 'cart-panel',
            }"
            :pt:header="{'style': 'display:none;'}"
        >
        <div class="cart-panel__overlay"></div>
        <div class="cart-panel__content" ref="cartPanelRef">
            <div class="flyout-header">
                <div class="flex-col">
                    <h2 class="headline-s">Cart</h2>
                    <span class="paragraph-details"> {{ currentList.total_styles }} Styles | {{ currentList.total_skus }} SKUs | {{ currentList.total_quantity }} Quantity | {{ subTotal }}</span>
                </div>
                <div class="flex-col">
                    <a @click.prevent="toggleDrawer" href="#" class="close-drawer">
                        <CloseIcon alt="Close Cart" />
                    </a>
                    <!-- <Link :href="route('cart.show')">Edit Cart</Link> -->
                </div>
            </div>
            <ListItem
                v-for="item in items"
                :key="item.list_item_id"
                :list_item="item"
                :only="['items', 'current_list']"
            />
            </div>
        </PrimeDrawer>
    </Layout>
</template>
<script lang="ts" setup>
    import Layout from "@/Shared/Layout.vue";
    import ListItem from "@/components/cart/ListItem.vue";
    import { usePage, Link, router } from "@inertiajs/vue3";
    import { computed, ref, inject } from "vue";
    // import { route } from "ziggy-js";
    import { storeToRefs } from "pinia";
    import { useSettingsStore } from "@/store/settings";
    import { formatPrice } from "@/helpers/composables/usePriceFormatting"
    import { onClickOutside } from "@vueuse/core";
    import UploadResaleCertificate from "@/components/UploadResaleCertificate.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    import WarningIcon from "@icons/notiftcation-warning-icon.svg";
    const settingsStore = useSettingsStore();
    let { currentList } = storeToRefs(settingsStore);
    let route = inject("route");
    let subTotal = computed(() => {
        return `$${formatPrice(currentList.value.total)}`;
    });

    let step = computed(() => usePage().props.step);
    let stepTitle = computed(()=>{
        if (step.value === 'shipping') {
            return 'Shipping';
        } else if (step.value === 'billing') {
            return 'Billing & Payment';
        } else if (step.value === 'review') {
            return `Review & Place ${usePage().props?.billing?.order_type ?? 'Order'}`;
        }
        return '';
    })
    let hasResaleCertificate = computed(() => {
        if (["billing", "review"].includes(step.value)) {
            return usePage().props.hasResaleCertificate;
        }
        return null;
    });
    
    let shippingUsa = computed(() => {
        return usePage().props.shippingUsa;
    });

    let shippingRegion = computed(() => {
        return usePage().props.shippingRegion?.name ?? '';
    });

    let showDrawer = ref(false);

    function toggleDrawer() {
        if(showDrawer.value){
            showDrawer.value = !showDrawer.value;
            return;
        }
        router.reload({
            only: ['items'],
            onSuccess: () => {
                showDrawer.value = !showDrawer.value;
            }
        })
    }

    let items = computed(() => {
        return usePage().props.items ?? [];
    });

    let uploadMessage = ref({});

    let shippingRoute = computed(()=>{
        return route('checkout.shipping');
    })

    let billingRoute = computed(()=>{
        return route('checkout.billing');
    })

    let reviewRoute = computed(()=>{
        return route('checkout.review');
    })


    let cartPanelRef = ref();

    onClickOutside(cartPanelRef, () => {
        showDrawer.value = false;
    });
</script>
